const kodePenjual = 'Kode Penjual';
export default {
    widgetEnable: 'Aktifkan Widget',
    signInText: 'Masuk ke akun Anda',
    password: 'Kata Sandi',
    passwordBNI: 'Masukkan password',
    login: 'Masuk',
    signin: 'Masuk',
    loginTooltip1: 'masukan nama',
    loginTooltip2: 'masukan password',
    forgotPassword: 'Lupa Kata Sandi',
    registerNow: 'Daftar',
    registerHere: 'Daftar di sini',
    dontHaveAccount: 'Belum memiliki Akun ? ',
    loginText: 'Selamat Datang di ASYX X4',
    taskManagement: 'Manajemen Tugas',
    search: 'Cari',
    reset: 'Atur Ulang',
    businessKey: 'Kode Bisnis',
    name: 'Nama',
    companyName: 'Nama Perusahaan',
    downPaymentGreater: 'Uang muka tidak boleh lebih dari total pesanan',
    clientName: 'Nama Klien',
    created: 'Tanggal Pembuatan',
    action: 'Aksi',
    actions: 'Aksi',
    taskDetail: 'Rincian Tugas',
    bniDirect: 'BNI Direct',
    key: 'Kunci',
    upcomingSettlementEmailNotification: 'Notifikasi Email Pembayaran dimuka',
    notificationSettings: 'Pengaturan Notifikasi',
    value: 'Nilai',
    settlementDetail: 'Rincian Pelunasan',
    accept: 'Terima',
    approve: 'Setuju',
    reject: 'Tolak',
    amend: 'Amend',
    complete: 'Selesai',
    edit: 'Sunting',
    revise: 'Revisi',
    documentList: 'Daftar Dokumen',
    documentDetail: 'Detail Dokumen',
    documentType: 'Jenis Dokumen',
    specificReference: 'Referensi Spesifik',
    transactionFilter: 'Filter Transaksi',
    specificDocumentStatus: 'Status Dokumen Spesifik',
    amountRange: 'Amount Range',
    periodRange: 'Period Range',
    dateRange: 'Rentang Waktu',
    advanceSearch: 'Lanjutan',
    documentStatus: 'Status Dokumen',
    period: 'Periode',
    amount: 'Nominal',
    amountMinimum: 'Jumlah Minimum',
    amountMaximum: 'Jumlah Maksimum',
    documentReference: 'Referensi Dokumen',
    reference: 'Referensi',
    seller: 'Penjual',
    buyer: 'Pembeli',
    status: 'Status',
    dueDate: 'Tanggal Jatuh Tempo',
    currency: 'Mata Uang',
    type: 'Tipe',
    received: 'Diterima',
    dateReceived: 'Tanggal Terima',
    accountDetail: 'Detail Akun',
    disbursementDetails: 'Detail Pencairan',
    disbursementTransferDate: 'Tanggal Dibayar',
    settlementTransferDate: 'Tanggal Pelunasan',
    paymentDate: 'Tanggal Dibayar',
    maturityDate: 'Tanggal Jatuh Tempo',
    totalAmountDoc: 'Jumlah total dokumen',
    totalNumber: 'Hasil',
    userManagement: 'Manajemen Akun Pengguna',
    bankManagement: 'Manajemen Bank',
    bankInformation: 'Tambah Informasi Bank',
    localBankCode: 'Kode Bank Lokal',
    branchCode: 'Kode Cabang',
    postCode: 'Kode Pos',
    'bankName.isEmpty': 'Nama Bank tidak boleh kosong',
    bankInformationisAlreadyExist: 'Informasi bank sudah ada',
    bankInformationHasBeenCreated: 'Informasi bank telah dibuat',
    deleteMessage: 'Apakah kamu yakin akan menghapus data',
    bulkMessage: 'Apakah kamu ingin',
    followData: 'data berikut ?',
    add: 'Tambah',
    userName: 'Nama Pengguna',
    userNameBNI: 'Masukkan username',
    view: 'Lihat',
    delete: 'Hapus',
    cancel: 'Batal',
    deletePranota: 'Hapus Pra Nota',
    normalPayment: 'Pembayaran Normal',
    provideValidationMessages: '* Harap berikan informasi yang valid',
    provideValidSettlementAmount: '* Nilai tidak boleh lebih dari Outstanding',
    validationRegistrationNumber: `* Silakan isi dengan nomor 0 jika Anda tidak memiliki nomor registrasi`,
    validationUsernameMessages: '* Silahkan masukkan nama pengguna Anda',
    validationPasswordMessages: '* Silahkan masukkan kata sandi Anda',
    validationUpdatePasswordMessage:
        '* Silahkan sertakan angka, kapital, huruf kecil, simbol minimal 9 karakter.',
    save: 'Simpan',
    userDetail: 'Rincian Akun Pengguna',
    username: 'Nama Pengguna',
    firstName: 'Nama Depan',
    middleName: 'Nama Tengah',
    lastName: 'Nama Akhir',
    email: 'Email',
    lastLoginTime: 'Waktu Login Terakhir',
    account: 'Akun',
    emailAddress: 'Alamat Surel',
    emailNotification: 'Pemberitahuan Surel',
    mobileNumber: 'Nomor Ponsel',
    smsNotification: 'Pemberitahuan SMS',
    city: 'Kota',
    country: 'Negara',
    languageISOCode: 'Kode ISO Bahasa',
    postalCode: 'Kode Pos',
    address: 'Alamat',
    jobTitle: 'Jabatan',
    personTitle: 'Gelar',
    idType: 'Jenis Identitas',
    idNumber: 'Nomor Identitas',
    otp: 'One Time Password (OTP)',
    settings: 'Pengaturan',
    pph23Flagging: 'PPh 23',
    deleteUserLDAP: 'Hapus Akun LDAP',
    createUserLDAP: 'Buat Akun LDAP',
    resetPassword: 'Atur Ulang Kata Sandi',
    option: 'Pilihan',
    organizationManagement: 'Managemen Organisasi',
    organizationDetail: 'Rincian Organisasi',
    fullName: 'Nama Lengkap',
    timezone: 'Zona Waktu',
    contactPerson: 'Pihak Yang Dapat Dihubungi',
    contactPersonDepartment: 'Departemen Pihak Yang Dapat Dihubungi',
    contactPersonPhone: 'Nomor Telepon Yang Dapat Dihubungi',
    contactPersonEmail: 'Alat Surel Pihak Yang Dapat Dihubungi',
    industry: 'Industri',
    subIndustry: 'Sub Industri',
    billingAccountName: 'Nama Akun Tagihan',
    billingAccountNumber: 'Nomor Akun Tagihan',
    billingTaxable: 'Pengenaan Pajak Tagihan',
    calendar: 'Kalender',
    authorization: 'Otorisasi',
    organizationCalendar: 'Kalender Organisasi',
    organizationCalendarDetail: 'Rincinan Kalender Organisasi',
    exclusions: 'Pengecualian',
    addExclusions: 'Tambah Pengecualian',
    date: 'Tanggal',
    description: 'Deskripsi',
    organizationAuthorization: 'Otorisasi Organisasi',
    organization: 'Organisasi',
    organizations: 'Organisasi',
    role: 'Otoritas',
    user: 'Pengguna',
    authorizationDetail: 'Rincian Otorisasi',
    authorizationDetailForm: 'Formulir Rincian Otorisasi',
    roleManagement: 'Manajemen Otoritas',
    roleDetail: 'Rincian Otoritas',
    rolePermission: 'Perizinan Otoritas',
    roleAssign: 'Pemberian Otoritas',
    programManagement: 'Manajemen Program',
    programDetail: 'Rincian Program',
    supportedCurrencies: 'Mata Uang Yang Didukung',
    funderEnable: 'Aktivasi Penyandang Dana',
    funderMultiple: 'Lebih Dari Satu Penyandang Dana',
    funderConfigurations: 'Konfigurasi Penyandang Dana',
    buyerEnable: 'Aktivasi Pembeli',
    buyerMultiple: 'Lebih dari Satu Pembeli',
    buyerConfigurations: 'Konfigurasi Pembeli',
    sellerEnable: 'Aktivasi Penjual',
    sellerMultiple: 'Lebih dari Satu Penjual',
    sellerConfigurations: 'Konfigurasi Penjual',
    pleaseSelect: 'Silahkan pilih...',
    contractManagement: 'Manajemen Kontrak',
    contractDetail: 'Rincian Kontrak',
    contractName: 'Nama Kontrak',
    contractAdd: 'Tambah Contract',
    contractEdit: 'Ubah Contract',
    assignProgram: 'Tetapkan Program',
    deactivatedContract: 'Nonaktifkan Kontrak',
    organizationName: 'Nama Organisasi',
    buyerOrganizations: 'Organisasi Pembeli',
    sellerOrganizations: 'Organisasi Penjual',
    funderOrganizations: 'Organisasi Penyandang Dana',
    uploadQuotes: 'Unggah Penawaran',
    upload: 'Unggah',
    buyerName: 'Nama Pembeli',
    supplierCode: 'Kode Supplier',
    supplierName: 'Nama Supplier',
    sellerName: 'Nama Penjual',
    areaCode: 'Kode Area',
    salesCode: kodePenjual,
    quoteNumber: 'Nomor Pemesanan',
    paymentTerm: 'Jangka Waktu Pembayaran',
    warehouseCode: 'Kode Gudang',
    deliveryFrom: 'Alamat Pengiriman ',
    deliveryTo: 'Alamat Penerima ',
    creationDate: 'Tanggal Pembuatan',
    expectedDeliveryDate: 'Perkiraan Tanggal Pengiriman',
    addLineItem: 'Tambah Barang',
    code: 'Kode',
    uom: 'Satuan',
    price: 'Harga',
    qty: 'Banyaknya',
    vat: 'PPN',
    discount: 'Diskon',
    submit: 'Simpan',
    createQuote: 'Buat Penawaran',
    createInvoice: 'Buat Faktur',
    createShippingLetter: 'Buat Surat Pengiriman',
    senderName: 'Nama Pengirim',
    receiverName: 'Nama Penerima',
    deliveryDate: 'Tanggal Pengiriman',
    expiryDate: 'Tanggal Kedaluwarsa',
    lineItems: 'Baris Produk',
    itemCode: 'Kode Produk',
    no: 'No.',
    documentView: 'Tampilan Dokumen',
    despatchAdvice: 'Surat Jalan',
    tracingNumber: 'Nomor Pelacakan',
    buyerCode: 'Kode Pembeli',
    buyerFullName: 'Nama Pembeli',
    buyerContact: 'Kontak Pembeli',
    sellerCode: kodePenjual,
    sellerFullName: 'Nama Penjual',
    sellerContact: 'Kontak Penjual',
    sellerConfiguration: 'Konfigurasi Penjual',
    orderReference: 'Nomor Pesanan',
    orderDate: 'Tanggal Pemesanan',
    receiveDate: 'Tanggal Diterima',
    despatchedQuantity: 'Jumlah Yang Dikirim',
    receivedQuantity: 'Jumlah Yang Diterima',
    serviceLevel: 'Tingkat Layanan',
    invoice: 'Faktur',
    buyerNPWP: 'NPWP Pembeli',
    sellerNPWP: 'NPWP Penjual',
    despatchAdviceReference: 'Nomor Surat Jalan',
    receivingAdviceReference: 'Nomor Surat Penerimaan',
    receivingAdviceDate: 'Tanggal Penerimaan',
    invoiceReference: 'Nomor Faktur',
    taxSerialNumber: 'Nomor Faktur Pajak',
    vatAmount: 'PPN',
    totalAmount: 'Jumlah Total',
    order: 'Pesanan',
    billingStatement: 'Tagihan',
    quote: 'Penawaran',
    receivingAdvice: 'Surat Penerimaan',
    despacthAdviceReference: 'Nomor Surat Jalan',
    organizationSales: 'Organisasi Penjual',
    area: 'Wilayah',
    salesDetail: 'Sales Detail',
    oneTimePassword: 'One Time Password',
    pleaseEnterYourReceiveCode: 'Please Enter Your Receive Code',
    enterReceiveCode: 'Enter Receive Code',
    enableOTP: 'Enable OTP',
    sendCode: 'Send Code',
    indonesian: 'Indonesia',
    english: 'English',
    uzbekistan: 'Uzbekistan',
    russian: 'Rusia',
    roleSelection: 'Pilihan Otoritas',
    userSelection: 'Pilihan Pengguna',
    taskName: 'Nama Tugas',
    shippingLetter: 'Shipping Letter',
    senderContact: 'Kontak Pengirim',
    street: 'Street',
    restrictions: 'Pembatasan',
    senderTelephone: 'Ponsel Pengirim',
    warehouse: 'Gudang',
    shippingNumber: 'Nomor Pengiriman',
    shippingDate: 'Tanggal Pengiriman',
    receiverContact: 'Kontak Penerima',
    receiverTelephone: 'Ponsel Penerima',
    totalColie: 'Total Colie',
    uploadAttachment: 'Unggah Dokumen',
    register: 'Daftar',
    registerText: 'Buat Akun Kamu',
    createAccount: 'Buat Akun',
    quoteReference: 'Referensi Penawaran',
    quoteCurrency: 'Mata Uang Penawaran',
    quoteDate: 'Tanggal Penawaran',
    orderCurrency: 'Mata Uang Pesanan',
    fileName: 'Nama File',
    requestQuantity: 'Permintaan Jumlah',
    invoiceDate: 'Tanggal Faktur',
    sender: 'Pengirim',
    organizationParent: 'Organization Parent',
    grandTotal: 'Total Keseluruhan',
    parentCompany: 'Perusahaan Induk',
    documentTypeStatus: 'Tipe & Status Dokumen',
    assetTypeStatus: 'Tipe Asset & Status',
    lineItemRevision: 'Line Item Revision',
    assetStatus: 'Status Asset',
    backToLoginPage: 'Kembali ke halaman login',
    printPdf: 'Print Pdf',
    virtualAccountNumber: 'Nomor Akun Virtual',
    remark: 'Catatan',
    registrationNumber: 'Nomor Pendaftaran',
    details: 'Rincian',
    configProperty: 'Property',
    configValue: 'Value',
    accountType: 'Tipe Account',
    accountNumber: 'Nomor Akun',
    showRelativeTime: 'Tampilkan Waktu Relatif',
    showDocumentRead: 'Tampilkan Status Dokumen Telah Dibaca',
    funderRequiredAccountTypes: 'Daftar Tipe Akun Funder',
    buyerRequiredAccountTypes: 'Daftar Tipe Akun Pembeli',
    sellerRequiredAccountTypes: 'Daftar Tipe Akun Penjual',
    financialRequest: 'Financial Request',
    paymentId: 'Payment ID',
    referenceSourceDetail: 'Reference Source Detail',
    referenceSourceEdit: 'Reference Source Edit',
    ReferenceSourceAdd: 'Reference Source Add',
    financingTenor: 'Financing Tenor',
    calculationStartDate: 'Tanggal Mulai Kalkulasi',
    maximumFinancingTenor: 'Maximum Financing Tenor',
    interestRate: 'Interest Rate',
    commissionAmount: 'Commission Amount',
    total: 'Total',
    financialInformation: 'Financial Information',
    whtinterstRate: 'WHT interst Rate',
    interestAmount: 'Interest Amount',
    requestDate: 'Request Date',
    customerType: 'Tipe Pelanggan',
    about: 'Tentang',
    interestIndex: 'Interest Index',
    contactUs: 'Hubungi Kami',
    download: 'Unduh',
    uploadAccurate: 'Upload Accurate',
    sales: 'Sales',
    approvalMatrix: 'Matriks Persetujuan',
    approvalMatrixList: 'List Matriks Persetujuan',
    approvalMatrixDetail: 'Detail Matriks Persetujuan',
    productMaintenance: 'Pengaturan Produk',
    itemDescription: 'Deskripsi Barang',
    size: 'Ukuran',
    priceList: 'Price List',
    priceTier: 'Price Tier',
    productDetail: 'Rincian Produk',
    productCreate: 'Pembuatan Produk',
    addPrice: 'Add Price',
    addReferenceRate: 'Add Reference Rate',
    addCommissionSetting: 'Tambah Pengaturan Komisi',
    stockValidation:
        'Tidak dapat melanjutkan transaksi ini, silakan mengisi kembali stok gudang Anda sebelum melanjutkan',
    failedValidation: 'Gagal proses tugas',
    levelType: 'Tipe Level',
    dateCreated: 'Creation Date',
    maximumCreditLine: 'Maximum Credit Line',
    outstandingCredit: 'Outstanding Credit',
    availableCreditLimit: 'Available Credit Limit',
    funderName: 'Funder Name',
    maximumTenor: 'Maximum Tenor',
    financingPercentage: 'Financing Percentage',
    invoiceAmount: 'Nominal',
    invoiceDiscount: 'Diskon faktur',
    interestCost: 'Interest Cost',
    fundedAmount: 'Funded Amount',
    currentTenor: 'Current Tenor',
    assets: 'Aset',
    asset: 'Aset',
    assetType: 'Tipe Aset',
    assetAmount: 'Jumlah Aset',
    originalAmount: 'Jumlah',
    funder: 'Funder',
    createNew: 'Buat Baru',
    addLevel: 'Tambah Level',
    addGroup: 'Tambah Grup',
    groupName: 'Nama Grup',
    addUser: 'Tambah Penyetuju',
    approverList: 'List Penyetuju',
    minimumApprover: 'Penyetuju Minimum',
    fundingRequest: 'Financing Statement',
    expectedDisbursementDate: 'Expected Disbursement Date',
    expectedSettlementDate: 'Perkiraan Tanggal Pelunasan',
    requestedCredit: 'Requested Credit',
    totalLimit: 'Total Limit',
    revisedMessage: 'Are you sure want to revise this document',
    totalOutstanding: 'Total Outstanding',
    totalLimitUtilization: 'Total Limit Utilization',
    referenceRate: 'Reference Rate',
    rateChange: 'Perubahan Rate',
    rateChangeLockStatus: 'Status Rate Terkunci',
    suspension: 'Suspension',
    commissionRate: 'Commission Rate',
    spread: 'Spread',
    vehicleNumber: 'Nomor Kendaraan',
    downPaymentReference: 'Down Payment Reference',
    interestCalculationMethod: 'Interest Calculation Method',
    brokerFee: 'Broker Fee',
    othersFee: 'Others Fee',
    technologyFee: 'Technology Fee',
    insuredPercentage: 'Insured Percentage',
    insuredAmount: 'Insured Amount',
    creditInsurer: 'Credit Insurer',
    stage: 'Stage',
    disbursementDate: 'Disbursement Request Date',
    eligibleAmount: 'Eligible Amount',
    disbursementAmount: 'Disbursement Amount',
    discountFee: 'Discount Fee',
    arrearsFee: 'Arrears Fee',
    lateFee: 'Late Fee',
    payment: 'Payment',
    feeType: 'Fee Type',
    calculationMethod: 'Calculation Method',
    calculationRate: 'Calculation Rate',
    calculationType: 'Calculation Type',
    penaltyCalculationType: 'Penalty Calculation Type',
    calculationResult: 'Calculation Result',
    arrears: 'Arrears',
    transfer: 'Transfer',
    settlementDate: 'Tanggal Pelunasan',
    transferDate: 'Transfer Date',
    actualDisbursementDate: 'Actual Disbursement Date',
    fromAccount: 'From Account',
    fromAccountNumber: 'From Account Number',
    soapResponse: 'Response',
    soapNarative: 'Narative',
    toAccount: 'To Account',
    toAccountNumber: 'To Account Number',
    amountType: 'Amount Type',
    feeDetail: 'Fee Detail',
    rateChangesHistory: 'Rate Change History',
    feeInformation: 'Informasi Biaya',
    chargeDetail: 'Charge Details',
    disbursement: 'Disbursement',
    settlement: 'Settlement',
    programName: 'Program Name',
    programDescription: 'Program Description',
    stageConfigurations: 'Stage Configurations',
    stageNumber: 'Stage Number',
    requiredAccountTypes: 'Account Types',
    insurance: 'Insurance',
    organizationCode: 'Organization Code',
    funderSelection: 'Co-Funding',
    funderProperty: 'Funder Property',
    buyerProperty: 'Buyer Property',
    sellerProperty: 'Seller Property',
    dailyCharge: 'Daily Charges',
    requestStatement: 'Request Statement',
    dateUpdated: 'Date Updated',
    financialRequestReference: 'Financial Request Reference',
    documentChecking: 'Document Checking',
    close: 'Tutup',
    disbursementHistory: 'Disbursement History',
    settlementHistory: 'Settlement History',
    totalDailyCharges: 'Total Daily Charges',
    disburseAmountValidation: '* Nilainya harus sama dengan Eligible Amount',
    assetDate: 'Asset Date',
    revisedDate: 'Tanggal Revisi',
    assetDetail: 'Asset Detail',
    notifications: 'Notifikasi',
    loadMore: 'Muat Lagi!',
    repaymentAmount: 'Repayment Amount',
    remainingAmount: 'Remaining Amount',
    outstandingAmount: 'Outstanding Amount',
    residual: 'Residual',
    settlementBookingDate: 'Settlement Booking Date',
    actualSettlementDate: 'Actual Settlement Date',
    processedDocument: 'Financing Statement',
    settlementAmount: 'Settlement Amount',
    loginContactUs: 'Butuh Bantuan ? Hubungi Kami !',
    assetCreationDate: 'Asset Creation Date',
    percentage: 'Persentase',
    automatic: 'Automatic',
    suspend: 'Suspend',
    noConfigurations: 'No Configurations Added.',
    financialOrganization: 'Financial Organization',
    addFinancialOrganization: 'Add Financial Organization',
    editFinancialOrganization: 'Edit Financial Organization',
    accountName: 'Nama Akun',
    bankCode: 'Kode Bank',
    branch: 'Branch',
    branchName: 'Nama Branch',
    bankName: 'Nama Bank',
    bankAddress: 'Alamat Bank',
    swiftCode: 'Kode SWIFT',
    bankDetails: 'Rincian Bank',
    approvalConfirm: 'Mohon konfirmasi persetujuan informasi bank',
    addNew: 'Add New',
    whtInterest: 'WHT Interest',
    whtInterestAmount: 'WHT Interest Amount',
    whtProcessingFee: 'WHT Processing Fee',
    whtProcessingFeeAmount: 'WHT Processing Fee Amount',
    processingFee: 'Processing Fee',
    totalDisbursementAmount: 'Total Disbursement Amount',
    rate: 'Rate',
    rating: 'Penilaian',
    leaveComment: 'Tinggalkan komentar',
    errorRating: 'Penilaian wajib di isi',
    method: 'Method',
    interest: 'Interest',
    forms: 'Formulir',
    arrears_on_settlement: 'Arrears on Settlement',
    bankCharge: 'Bank Charge',
    methods: 'Methods',
    disbursementMode: 'Disbursement Mode',
    cost: 'Cost',
    maximumAmount: 'Maximum Amount',
    property: 'Property',
    totalCharge: 'Total Charge',
    extensionSetting: 'Pengaturan Ekstensi',
    penaltyEnabled: 'Penalty Enabled',
    extensionInterest: 'Extension Interest',
    penaltyGracePeriod: 'Penalty Grace Period',
    cycle: 'Penalty Cycle',
    penaltyInterest: 'Penalty Interest',
    freeze: 'Freeze',
    days: 'Hari',
    interestOnPenalty: 'Interest On Penalty',
    arrearsFeeAfterDueDate: 'Arrears Fee After Due Date',
    dailyChecking: 'Daily Checking',
    addPenaltyInterest: 'Add',
    penalty: 'Penalty',
    addPenalty: 'Add Penalty',
    extend: 'Extend',
    maximumExtendedTenor: 'Maximum Extended Tenor',
    extensionDate: 'Extension Date',
    limitContractSetting: 'Limit Contract Setting',
    maximumCreditLimit: 'Maximum Credit Limit',
    overridePercentage: 'Override Percentage',
    assetPercentage: 'Aset Percentage',
    fundingPercentage: 'Funding Percentage',
    activationSetting: 'Activation Setting',
    overrideAmount: 'Override Amount',
    enabled: 'Enabled',
    litigation: 'Litigation',
    proformaInvoice: 'Proforma Invoice',
    flowConfigurations: 'Flow Configurations',
    programType: 'Program Type',
    flowPreview: 'Flow Preview',
    propertySetting: 'Property Setting',
    inventoryChecking: 'Inventory Checking',
    partlyDespatchAdvice: 'Partly Despatch Advice',
    uploadInvoices: 'Upload Invoices',
    uploadInventory: 'Upload Inventory',
    uploadProduct: 'Upload Product',
    shippingInformation: 'Informasi Pengiriman',
    participantInformation: 'Informasi Partisipan',
    otherInformation: 'Informasi Lainnya',
    incoTerm: 'Incoterms',
    product: 'Product',
    vesselId: 'Vessel ID',
    billOfLadingDate: 'Shipping Date',
    createOrder: 'Create Order',
    standardPercentage: 'Kualitas Kadar Air',
    item: 'Item',
    balanceStock: 'Balance Stock',
    valueUpdate: 'Value Update',
    updateStock: 'Update Stock',
    invoiceCurrency: 'Mata Uang Faktur',
    invoiceNumber: 'Nomor Faktur',
    incoterm: 'Incoterm',
    invoiceLineItem: 'Invoice Line Item',
    loadPort: 'Load Port',
    dischargePort: 'Discharge Port',
    daysDivisorTitle: 'Number of Days Divisor',
    divisor: 'Divisor',
    uploadOrder: 'Upload Order',
    noAction: 'No Action',
    despatchGoodsConfirmation: 'Konfirmasi Pengiriman Barang',
    despatchAdviceDate: 'Tanggal Surat Jalan',
    despatchAdviceInventoryChecking: 'Pengecekan Inventaris',
    proformaInvoiceReference: 'Proforma Invoice Reference',
    proformaInvoiceDate: 'Proforma Invoice Date',
    buyerContactPhone: 'Nomor Kontak Pembeli',
    sellerContactPhone: 'Nomor Kontak Penjual',
    buyerAccountNumber: 'Nomor Rekening Pembeli',
    sellerAccountNumber: 'Nomor Rekening Penjual',
    actualWaterContent: 'Kadar Air yang Diterima',
    waterContentReduction: 'Rafaksi',
    proposalRejectionDays: 'Proposal Rejection Days',
    cutOffTime: 'Cut Off Time (HH:MM:SS)',
    minimumFinancingTenor: 'Minimum Financing Tenor',
    maximumPassDueDate: 'Maximum Pass Due Date',
    buyerRecourse: 'Buyer Recourse',
    buyerSetting: 'Buyer Setting',
    sellerRecourse: 'Seller Recourse',
    sellerSetting: 'Seller Setting',
    residuals: 'Residuals',
    assetSettlement: 'Asset Settlement',
    repaymentDate: 'Repayment Date',
    dilutions: 'Dilutions',
    manualSettlement: 'Manual Settlement',
    assetNumber: 'Asset Number',
    settle: 'Settle',
    dilution: 'Dilution',
    remarks: 'Remarks',
    generalLedger: 'General Ledger',
    invoicePurchased: 'Invoice Purchased',
    accountPayable: 'Account Payable',
    bankGlNumber: 'Bank Gl Number',
    sdReceipt: 'Sd Receipt',
    interestIncome: 'Interest Income',
    penaltyInterestIncome: 'Penalty Interest Income',
    processingFeeIncome: 'Processing Fee Income',
    bankCharges: 'Bank Charges',
    prepaidAmount: 'Prepaid Amount',
    downPayment: 'Uang Muka',
    accountReceivables: 'Account Receivables',
    vatCode: 'Vat Code',
    disbursementApproval: 'Disbursement Approval',
    attachmentList: 'Attachment List',
    lineItemNoData: 'Data Tidak Ditemukan.',
    loading: 'Memproses...',
    fscm: 'Manajemen Rantai Pasok Keuangan',
    pleaseSignIn: 'Mohon Masuk',
    convergenceTag1: 'Menyediakan solusi pembiayaan yang inovatif,',
    convergenceTag2: 'sehingga Anda dapat fokus pada pengembangan bisnis Anda.',
    taskEditDocumentMessage: 'Dokumen berhasil di edit.',
    rejectionRemark: 'Rejection Remark',
    priceCorrection: 'Price Correction',
    overdueDays: 'Overdue Days',
    creditRating: 'Peringkat Kredit',
    allowFinance: 'Izinkan Untuk Membiayai',
    fromInvoice: 'Dari Faktur',
    invoiceRecalculate: '* Perubahan total harga akan muncul ketika dokumen sudah disimpan.',
    qualityAnalysisResult: 'Hasil Analisa Mutu',
    testQuality: 'Hasil Uji Masak',
    standardText: 'Sesuai Standar',
    notStandardText: 'Tidak Sesuai Standar',
    clearSelection: 'Clear Selection',
    receivedQuantityChecking: 'Received Quantity Checking',
    discountApproval: 'Discount Approval',
    serviceProviderApproval: 'Service Provider Approval',
    relatedAttachmentList: 'Daftar Lampiran Terkait',
    disbursementTransferApproval: 'Disbursement Transfer Approval',
    settlementTransferApproval: 'Settlement Transfer Approval',
    bookingOffice: 'Booking Office',
    jobManagement: 'Job Management',
    JobScheduler: 'Job Scheduler',
    JobSchedulerTrigger: 'Job Scheduler Trigger',
    JobExecutionDetails: 'Job Execution Details',
    jobName: 'Job Name',
    lastRunTime: 'Last Run Time',
    nextRunTime: 'Next Run Time',
    lastResult: 'Last Result',
    approval: 'Persetujuan',
    JobSchedulers: 'Job Schedulers',
    JobExecutions: 'Job Executions',
    jobInstances: 'Job Instances',
    calendarName: 'Calendar Name',
    cronExpression: 'Cron Expression',
    jobActiveEntity: 'Job Active Entity',
    jobPerspective: 'Job Perspective',
    state: 'State',
    addTrigger: 'Add Trigger',
    start: 'Start',
    scheduler: 'Scheduler',
    enable: 'Enable',
    disable: 'Disable',
    activeContract: 'Aktif Kontrak',
    referenceSource: 'Reference Source Enabled',
    'com.asyx.x4.document.asset.already_have_fs':
        'Faktur tersebut sudah terbentuk Financing Statement',
    recalculate: 'Menghitung',
    'No Data Available': 'Data tidak tersedia',
    'com.asyx.x4.finprocess.settlement.invalid-settlement-amount':
        'Jumlah pelunasan tidak boleh lebih besar dari Jumlah hutang.',
    'com.asyx.x4.user.nofill': 'Silakan isi informasinya',
    'com.asyx.x4.user.onlyAlphanumeric_username': 'Nama pengguna tidak valid',
    'com.asyx.x4.user.maximumCharacter_username': 'Nama pengguna tidak valid',
    'com.asyx.x4.user.onlyAlphabetic_name': 'Nama tidak valid',
    'com.asyx.x4.user.manimumCharacter_name': 'Nama tidak valid',
    'com.asyx.x4.user.invalidFormat_email': 'Alamat email tidak valid',
    'com.asyx.x4.user.maximumCharacter_email': 'Alamat email tidak valid',
    'com.asyx.x4.user.onlyNumeric_mobileNumber': 'Nomor ponsel tidak valid',
    'com.asyx.x4.user.minimumCharacter_mobileNumber': 'Nomor ponsel tidak valid',
    'com.asyx.x4.user.weak_password': 'Kata sandi tidak valid',
    'com.asyx.x4.user.nofill_username': 'Silakan isi nama pengguna',
    'com.asyx.x4.user.nofill_name': 'Silakan isi nama',
    'com.asyx.x4.user.nofill_email': 'Silakan isi email',
    'com.asyx.x4.user.nofill_mobileNumber': 'Silakan isi nomor ponsel',
    'com.asyx.x4.user.nofill_password': 'Silakan isi kata sandi',
    'com.asyx.x4.date.nofill': 'Silakan pilih tanggal',
    'com.asyx.x4.calandar.nofill_name': 'Silakan isi nama',
    'com.asyx.x4.authorization.user-role_nofill': 'Silakan pilih otoritas dan pengguna',
    'com.asyx.x4.authorization.role_nofill': 'Silakan pilih otoritas',
    'com.asyx.x4.authorization.user_nofill': 'Silakan pilih pengguna',
    'com.asyx.x4.organization.nofill_reference': 'Referensi harus mengandung nilai',
    'com.asyx.x4.organization.onlyAlphanumeric_reference': 'Referensi tidak valid',
    'com.asyx.x4.organization.max_reference': 'Referensi tidak valid',
    'com.asyx.x4.organization.nofill_fullname': 'Nama Lengkap harus mengandung nilai',
    'com.asyx.x4.organization.max_fullname': 'Nama Lengkap tidak valid',
    'com.asyx.x4.organization.nofill_contactPerson': 'Kontak harus mengandung nilai',
    'com.asyx.x4.organization.onlyAlphanumeric_contactPerson': 'Kontak tidak valid',
    'com.asyx.x4.organization.max_contactPerson': 'Kontak tidak valid',
    'com.asyx.x4.organization.nofill_email': 'Email harus mengandung nilai',
    'com.asyx.x4.organization.invalidFormat_email': 'Email tidak valid',
    'com.asyx.x4.organization.max_email': 'Email tidak valid',
    'com.asyx.x4.organization.nofill_contactPersonPhone': 'Kontak telepon harus mengandung nilai',
    'com.asyx.x4.organization.onlyAlphanumeric_contactPersonPhone': 'Kontak telepon tidak valid',
    'com.asyx.x4.organization.max_contactPersonPhone': 'Kontak telepon tidak valid',
    'com.asyx.x4.organization.nofill_city': 'Kota harus mengandung nilai',
    'com.asyx.x4.organization.max_city': 'Kota tidak valid',
    'com.asyx.x4.organization.nofill_timeZone': 'Zona harus berisi nilai',
    'com.asyx.x4.organization.nofill_country': 'Negara harus berisi nilai',
    'com.asyx.x4.organization.max_country': 'Negara tidak valid',
    'com.asyx.x4.organization.nofill_address1': 'Alamat harus mengandung nilai',
    'com.asyx.x4.organization.max_address1': 'Alamat tidak valid',
    'com.asyx.x4.organization.nofill_registrationNumber': 'Nomor Registrasi harus berisi nilai',
    'com.asyx.x4.organization.nofill_contactPersonDepartment':
        'Kontak Departemen harus berisi nilai',
    'com.asyx.x4.organization.onlyAlphabetic_contactPersonDepartment':
        'Kontak Departemen tidak valid',
    'com.asyx.x4.organization.max_contactPersonDepartment': 'Kontak Departemen tidak valid',
    'com.asyx.x4.document.between5to50_refrence':
        'Jumlah karakter nomor faktur wajib berisi 5 sampai 50 karakter',
    'com.asyx.x4.invoice.mustPositive_amount': 'Jumlah harus bernilai positif',
    'com.asyx.x4.document.nofill_currency': 'Silakan pilih mata uang',
    'com.asyx.x4.invoice.nofill_buyerSeller':
        'Nama Pembeli dan Nama Penjual harus mengandung nilai!',
    'com.asyx.x4.invoice.nofill_amount': 'Jumlah harus mengandung nilai!',
    'com.asyx.x4.invoice.nofill_invoiceReference': 'Nomor Faktur harus mengandung nilai!',
    'com.asyx.x4.invoice.nofill_invoiceDate': 'Invoice Date should contain a value !',
    'com.asyx.x4.invoice.nofill_maturityDate': 'Maturity Date should contain a value !',
    'com.asyx.x4.invoice.nofill_billOfLadingDate': 'Bill of Lading Date should contain a value !',
    'com.asyx.x4.finprocess.statement.router.credit_limit_exceeded':
        'Financing Statement telah melampaui batas kredit maksimum Participant',
    'com.asyx.x4.finprocess.statement.router.requestor_suspend':
        'Pemohon telah ditangguhkan. Harap selesaikan transaksi tertunda yang ada untuk meminta pendanaan baru.',
    'com.asyx.x4.finprocess.statement.router.suspend_contract':
        'Akun Anda telah dibekukan. Mohon hubungi administrator untuk informasi lebih lanjut.',
    'com.asyx.x4.finprocess.statement.router.negative_funded_amount':
        'Jumlah pendanaan tidak boleh nol atau negatif.',
    'com.asyx.x4.contract.used_in_transaction':
        'Gagal menghapus kontrak karena kontrak ini sudah digunakan oleh transaksi lain.',
    'com.asyx.x4.error.unknown': 'Unknown error occured, please try again later.',
    'com.asyx.x4.error.network': 'Hubungan ke server gagal, mohon periksa koneksi internet anda.',
    'com.asyx.x4.document.between1to15_vehicleNumber': 'Panjang nomor kendaraan maksimum 15 digit',
    deleteProgramConfirmation: 'Apakah anda yakin ingin menghapus program ini ?',
    cantUndo: 'Proses ini tidak dapat dibatalkan.',
    noPermissionDocumentView: 'Anda tidak dapat mengakses dokumen ini.',
    noDataFound: 'Data tidak ditemukan.',
    'b2b.documentDetail': 'Detail Dokumen',
    'b2b.orderTo': 'Pesan Ke',
    'b2b.shipTo': 'Dikirim Ke',
    'b2b.orderInformation': 'Informasi PO',
    'b2b.poStatus': 'Status PO',
    'b2b.poDate': 'Tanggal PO',
    'b2b.poExpiredDate': 'Tanggal Kedaluwarsa PO',
    'b2b.poType': 'Tipe PO',
    'b2b.partialDelivery': 'Pengiriman Sebagian',
    'b2b.top': 'Pembayaran',
    totalTenor: 'Tenor Total',
    'b2b.producCode': 'Kode Produk',
    'b2b.productName': 'Nama Produk',
    'b2b.quantity': 'Jumlah Order',
    'b2b.price': 'Harga per unit',
    'b2b.items': 'List Produk',
    'b2b.discount': 'Disk : ',
    'b2b.discountAmount': 'Diskon',
    'b2b.luxuryTax': 'Pajak Barang Mewah',
    'b2b.totalPoAmount': 'Total Jumlah PO',
    'b2b.subtotal': 'Sub Total',
    'b2b.subTotalAfterDiscount': 'Sub Total Setelah Diskon',
    'b2b.npwp': 'NPWP',
    'b2b.telp': 'Telp',
    'b2b.attn': 'PIC',
    'b2b.fax': 'Fax',
    'b2b.customerInformation': 'Informasi Pelanggan',
    'b2b.billingInformation': 'Informasi Tagihan',
    'b2b.customer': 'Pelanggan',
    docstoreRole: 'Docstore Role',
    volume: 'Volume',
    fixedPrice: 'Harga Tetap',
    shortName: 'Nama Singkat',
    validFrom: 'Berlaku Dari',
    minimumAmount: 'Jumlah Minimum',
    taxable: 'Berpajak?',
    priceTiers: 'Tingkatan Harga',
    assignedEntities: 'Assigned Entities',
    pricingRules: 'Aturan Penetapan Harga',
    processVariable: 'Variabel Proses',
    'com.b2b.shortName.isNull': 'Nama Singkat tidak boleh kosong.',
    'com.b2b.validFrom.isNull': 'Berlaku Dari tidak boleh kosong.',
    'com.b2b.discount.isNull': 'Diskon tidak boleh kosong.',
    'com.b2b.minimumAmount.isNull': 'Jumlah Minimum tidak boleh kosong.',
    'com.b2b.amount.isNull': 'Jumlah tidak boleh kosong.',
    'com.b2b.priceTiers.isEmpty': 'Tingkatan Harga harus diisi minimal 1 item.',
    'com.b2b.priceTier.volume.isEmpty': 'Volume di Tingkatan Harga tidak boleh kosong.',
    'com.b2b.priceTier.fixedPrice.isEmpty': 'Harga Tetap di Tingkatan Harga tidak boleh kosong.',
    'com.b2b.priceTier.percentage.isEmpty': 'Persentase di Tingkatan Harga tidak boleh kosong.',
    'com.b2b.priceTier.processVariable.isEmpty':
        'Variabel Proses di Tingkatan Harga tidak boleh kosong.',
    priceMaintenance: 'Perawatan Harga',
    countryISOCode: 'Kode ISO Negara',
    faxNumber: 'Nomor Fax',
    customerName: 'Nama Kustomer',
    settleOrRevise: 'Lunasi atau Revisi',
    billingStatements: 'Laporan Tagihan',
    customer: 'Kustomer',
    registrationNo: 'No. Pendaftaran',
    revision: 'Revisi',
    statementDate: 'Tanggal Tagihan',
    minimumFee: 'Biaya Minimum',
    specification: 'Spesifikasi',
    valueAddedTax: 'Pajak Pertambahan Nilai (PPN)',
    requestedDisbursementDate: 'Requested Disbursement Date',
    requestedSettlementDate: 'Requested Settlement Date',
    signature: 'Tanda Tangan',
    signatureSender: 'Pengirim:',
    signatureReceiver: 'Penerima:',
    signatureDate: 'Tanggal:',
    addressOne: 'Address One',
    addressTwo: 'Address Two',
    'com.asyx.x4.user.password_missmatch': 'Kata sandi saat ini tidak cocok',
    'com.asyx.x4.uoa.updatepassword.invalid_length':
        'Sandi setidaknya harus terdiri dari 9 karakter.',
    'com.asyx.x4.uoa.updatepassword.no_symbol': 'Sandi harus mengandung simbol.',
    'com.asyx.x4.uoa.updatepassword.no_number': 'Sandi harus mengandung angka.',
    'com.asyx.x4.uoa.updatepassword.no_upper_case': 'Sandi harus mengandung huruf kapital.',
    'com.asyx.x4.uoa.updatepassword.no_lower_case': 'Sandi harus mengandung huruf kecil.',
    'com.asyx.x4.uoa.updatepassword.contain_space': 'Sandi tidak boleh mengandung spasi.',
    'com.asyx.x4.uoa.updatepassword.contain_symbol_number':
        'Sandi harus mengandung simbol dan angka.',
    'com.asyx.x4.uoa.updatepassword.symbol_number_upper':
        'Sandi harus mengandung simbol, angka, dan huruf kapital.',
    'com.asyx.x4.uoa.updatepassword.symbol_number_lower':
        'Sandi harus mengandung simbol, angka dan huruf kecil.',
    'com.asyx.x4.user.password_has_been_used':
        'Kata sandi ini telah digunakan sebelumnya. Silakan pilih kata sandi baru.',
    'com.asyx.x4.user.password_has_been_used_default':
        'Kata sandi ini telah digunakan sebelumnya. Silakan pilih kata sandi baru.',
    'com.asyx.x4.user.password_has_been_used_bni':
        'Kata sandi ini sudah pernah digunakan. Silakan pilih kata sandi yang berbeda.',
    'com.asyx.x4.uoa.updatepassword.contain_forbidden_special_characters':
        'Sandi mengandung simbol terlarang (& % =).',
    signatureApproved: 'Disetujui Oleh: Direktur Utama',
    'resetPassword.maximumAttempt': 'Sudah terlalu banyak request. (Maksimal 3 kali dalam sehari)',
    confirmPassword: 'Konfirmasi Kata Sandi',
    passwordResetSuccess:
        'Password berhasil diupdate, anda akan diteruskan ke halaman login dalam ',
    orClick: 'atau klik',
    here: 'di sini',
    showUploadProductTips:
        'Untuk mendaftarkan daftar produk dalam jumlah besar, anda dapat mengunggah Berkas pada ',
    thisPage: 'halaman ini',
    dontRemind: 'Jangan ingatkan lagi',
    goToLoginPage: ' untuk pergi sekarang.',
    signatureName: 'Nama:',
    transferAfterGR: 'Pembayaran Setelah Barang Diterima',
    transferAfterQualityApproval: 'Pembayaran Setelah Pemeriksaan Kualitas',
    transferAfterGRValidation: 'Mohon mengisi Pembayaran Setelah Barang Diterima.',
    transferAfterQualityApprovalValidation: 'Mohon mengisi Pembayaran Setelah Pemeriksaan Kualitas',
    'Apr On Asset Amount': 'APR on Asset Amount',
    'Apr On Disbursement Amount': 'APR on Disbursement Amount',
    'Apr On Eligible Amount': 'APR on Eligible Amount',
    'Apr On Original Amount': 'APR on Original Amount',
    'Percentage Of Asset Amount': '% of Asset Amount',
    'Percentage Of Disbursement Amount': '% of Disbursement Amount',
    'Percentage Of Eligible Amount': '% of Eligible Amount',
    'Percentage Of Original Amount': '% of Original Amount',
    apr_of_remaining_disbursement_amount: 'APR of Remaining Disbursement Amount',
    accountEnabled: 'Akun diaktifkan',
    accountDisabled: 'Akun dinonaktifkan',
    accountLocked: 'Akun dikunci',
    accountUnlocked: 'Akun dibuka',
    unlockAccount: 'Buka Account',
    showMore: 'Tampilkan Lebih ...',
    showMoredata: 'Tampilkan Lebih',
    showLessdata: 'Tampilkan Lebih sedikit',
    viewJobExecution: 'Lihat eksekusi',
    viewJobInstances: 'Lihat instansi',
    calculationTypeValue: 'Type',
    signatures: 'Tanda Tangan',
    apmsReference: 'Nama APMS',
    principalAmount: 'Jumlah Pokok',
    exportCsv: 'Ekspor CSV',
    exportPdf: 'Ekspor PDF',
    exportExcel: 'Ekspor Excel',
    exportXml: 'Ekspor XML',
    exportMt940: 'Ekspor MT940',
    'hover.accept.disbursement_approval':
        'Click on this button will disburse the Financing Statement.',
    'hover.accept.asset_financing_funder_approval':
        'Click on this button to proceed the Financing Statement document for disbursement initiation.',
    'hover.accept.asset_financing_requester_approval':
        'Click on this button to proceed the Financing Statement document to service provider or funder.',
    'hover.accept.service_provider_approval':
        'Click on this button to proceed the Financing Statement document to Funder approval.',
    'hover.reject.disbursement_approval':
        'Click on this button a rejection remark should be provided and the Financing Statement document will be fully rejected. Once rejected, Seller should initiate a new request in the future.',
    'hover.reject.asset_financing_funder_approval':
        'Click on this button will reject the Financing Statement document. Once rejected, Seller should initiate a new request in the future.',
    'hover.reject.service_provider_approval':
        'Click on this button will reject the Financing Statement document. Once rejected, Seller should initiate a new request in the future.',
    'hover.cancel.asset_financing_requester_approval':
        'Click on this button will cancel the Financing Statement initiation.',
    'hover.edit.service_provider_approval':
        'Click on this button to edit the Financing Statement document to upload supporting document(s).',
    'hover.edit.asset_financing_requester_approval':
        'Click on this button to edit the Financing Statement document to give an acknowledgement.',
    'hover.revise.disbursement_approval':
        'Click on this button a revision remark should be provided and the Financing Statement document will be sent back to the Funder Maker user for revision.',
    update: 'Update',
    totalPO: 'Jumlah PO',
    settlementForm: 'Form Pelunasan',
    attachFiles: 'Lampirkan File',
    chooseFile: 'Pilih File',
    addFile: 'Tambah Berkas',
    settlementConfirmation: 'Settlement Confirmation',
    attachments: 'Lampiran',
    createCreditNote: 'Create Credit Note',
    creditNote: 'Credit Note',
    beginingOfInvoiceAmount: 'Begining of Invoice Amount',
    endingOfInvoiceAmount: 'Ending of Invoice Amount',
    creditNoteAmount: 'Credit Note Amount',
    history: 'History',
    loggingIn: 'Logging in...',
    updatePassword: 'Perbarui Kata Sandi',
    enterCurrentPassword: 'Masukkan kata sandi saat ini',
    enterNewPassword: 'Masukkan kata sandi yang baru',
    generalErrorMessage: 'Telah terjadi kesalahan, mohon infokan kejadian ini ke support kami.',
    too_many_attempt:
        'Kata sandi telah dikirim 3 kali, harap tunggu hingga hari berikutnya atau hubungi Asyx Support.',
    assign: 'Assign',
    editCreditNoteAmount: 'Edit Credit Note Amount',
    assignCreditNote: 'Assign Credit Note',
    assignInvoice: 'Assign Invoice',
    selectInvoice: 'Select Invoice',
    interestIndexManagement: 'Manajemen Indeks Bunga',
    lastUpdate: 'Update Terakhir',
    interestIndexDetail: 'Rincian Indeks Bunga',
    InterestIndexAdd: 'Tambah Indeks Bunga',
    notificationTemplate: 'Notification Template',
    templateNotifCreated: 'Notifikasi Template berhasil terbuat.',
    templateNotifUpdated: 'Notifikasi Template berhasil diubah.',
    templateNotifDeleted: 'Notifikasi Template berhasil dihapus.',
    fromDate: 'From Date',
    toDate: 'To Date',
    rateUpdates: 'Rate Updates',
    reconciliation: 'Reconciliation',
    reconciliationAmount: 'Reconciliation Amount',
    otherCharges: 'Other Charges',
    additionalReimbursement: 'Additional Reimbursement',
    difference: 'Difference',
    reconcile: 'Reconcile',
    reconciliationForm: 'Reconciliation Form',
    confirm: 'Confirm',
    'com.asyx.x4.reconciliation.nofill_buyer': 'Please pick at least 1 buyer.',
    'com.asyx.x4.reconciliation.nofill_currencies': 'Please pick at least 1 currency.',
    'com.asyx.x4.reconciliation.nofill_repaymentDate': 'Repayment Date Must be Filled.',
    'com.asyx.x4.reconciliation.invalid_repayment_amount': 'Repayment Amount cannot be empty.',
    'com.asyx.x4.reconciliation.invalid_difference_amount': 'The Difference should be zero.',
    'com.asyx.x4.finconfig.referencesource.service.duplicate_combination_name_and_configuration':
        'Name and Configuration is already used.',
    'com.asyx.x4.finconfig.referencesource.service.duplicate_combination_name_and_days':
        'Configuration and Days is already used.',
    'Too many attempt':
        'Kata sandi telah dikirim 3 kali, harap tunggu hingga hari berikutnya atau hubungi Asyx Support.',
    buyerReference: 'Kode Pembeli',
    sellerReference: kodePenjual,
    creditNoteReference: 'Credit Note Reference',
    switchUserType: 'Ganti Tipe User',
    selectUserType: 'Pilih Tipe User',
    supplier: 'Pemasok',
    quoteFormLoading: 'Mempersiapkan formulir Anda, mohon menunggu sebentar ...',
    noLineItems: 'Belum ada item dipilih.',
    moneyMovementReport: 'Laporan Pergerakan Uang',
    trannsactionType: 'Tipe Transaksi',
    responseType: 'Tipe Respon',
    inactiveDialogTitle: 'Hai, apakah kamu masih di sana?',
    inactiveDialogMessage:
        'Untuk keamanan akun Anda, Anda akan dikeluarkan secara otomatis jika tidak ada aktivitas setelah beberapa waktu.',
    inactiveDialogButton: 'Ya, Mohon tunggu',
    tenor: 'Tenor',
    viewDetail: 'Lihat Rincian',
    switchUser: 'Akses User',
    totalUserSelected: 'Total User(s) dipilih : ',
    totalDocumentSelected: 'Total Dokumen dipilih : ',
    totalTaskSelected: 'Total Task dipilih : ',
    cloneUser: 'Duplikat User',
    cloneUsernameValidation: '* Nama pengguna harus berbeda dari pengguna aslinya.',
    paymentInformation: 'Informasi Pembayaran',
    priceType: 'Price Type',
    owner: 'Owner',
    discountType: 'Tipe Diskon',
    dataConfirmation: 'Konfirmasi Data',
    dataHoverError: 'Terdapat error pada file ini',
    dataHoverSuccess: 'File terverifikasi dan siap diupload.',
    csvReviewErrors: 'Mohon perbaiki terlebih dahulu :',
    'Arrears On Settlement': 'Arrears on Settlement',
    'com.task.validation.emptyQc': 'Mohon untuk mengisi form pengecekan kualitas terlebih dahulu.',
    'com.asyx.x4.qcvalidation.standardPercentage': 'Mohon untuk mengisi kualitas air.',
    'com.asyx.x4.qcvalidation.seedAmount': 'Mohon untuk mengisi jumlah biji.',
    'com.asyx.x4.qcvalidation.maxDirt': 'Mohon untuk mengisi jumlah maksimum kotoran.',
    'com.asyx.x4.qcvalidation.maxMushroom': 'Mohon untuk mengisi jumlah maksimum jamur.',
    'com.asyx.x4.qcvalidation.maxSkinContent': 'Mohon untuk mengisi jumlah maksimum.',
    'com.asyx.x4.qcvalidation.notSalty': 'Mohon untuk mengisi pilihan tidak asin.',
    calculating: 'Menghitung...',
    settlementValidation: 'Nominal pelunasan tidak boleh melebihi nominal tersisa.',
    seedAmount: 'Jumlah Biji',
    maxDirt: 'Kotoran Max',
    maxMushroom: 'Jamur Max',
    maxSkinContent: 'Kadar Kulit Max',
    notSalty: 'Tidak Berbau Asin',
    startPeriod: 'start Period',
    inactivityPeriod: 'Periode Tidak Aktif',
    emailNotificationactivation: 'Aktivasi Pemberitahuan Email',
    activeEmailNotification: 'Notifikasi Email Aktif',
    inActiveEmailNotification: 'Notifikasi Email Tidak Aktif',
    documentStatusActivation: 'Tampilkan Aktivasi Status Baca Dokumen',
    activeDocumentRead: 'Status Baca Dokumen Aktif',
    inActiveDocumentRead: 'Status Baca Dokumen Tidak Aktif',
    relativeTimeActivation: 'Tampilkan Aktivasi Waktu Relatif',
    activeRelativeTime: 'Tampilkan Waktu Relatif Aktif',
    inActiveRelativeTime: 'Tampilkan Waktu Relatif Tidak Aktif',
    otpActivation: 'Aktivasi Kata Sandi Satu Kali',
    activeOtp: 'Kata Sandi Satu Kali Aktif',
    inActiveOtp: 'Kata Sandi Satu Kali Tidak Aktif',
    accountStatus: 'Status Akun',
    enabledAccount: 'Akun Diaktifkan',
    disabledAccount: 'Akun Dinonaktifkan',
    lockedAccount: 'Akun Dikunci',
    ldapAccount: 'Akun LDAP',
    activeLdap: 'Akun LDAP Aktif',
    inActiveLdap: 'Akun LDAP Tidak Aktif',
    addBankInformation: 'Tambah Informasi Bank',
    additional: 'Penambahan',
    supplierList: 'Daftar Supplier',
    addSupplier: 'Tambah Supplier Baru',
    supplierEmail: 'Email Supplier',
    buyerList: 'Daftar Pembeli',
    addBuyer: 'Tambah Pembeli Baru',
    buyerEmail: 'Email Pembeli',
    phoneNumber: 'Nomor Telepon',
    requiredNote: '* Harus diisi',
    createAnother: 'Tambah Lagi',
    addParticipantSuccess: ' berhasil ditambahkan.',
    uncdfRegisterText: 'Lengkapi pendaftaran akun anda',
    ageRange: 'Rentang Usia',
    lessThan24: 'Di bawah 24 tahun',
    over24: 'Di atas 24 tahun',
    buyerOrSupplier: 'Apakah anda Pembeli atau Pemasok?',
    passwordDidNotMatch: '* Konfirmasi kata sandi tidak sama.',
    usernameAlphanumeric: '* Nama pengguna tidak boleh mengandung simbol.',
    usernameMin5: '* Nama pengguna minimal 5 karakter.',
    passwordMin: '* Kata sandi minimal 9 karakter.',
    passwordAlphanumeric:
        '* Kata Sandi harus mengandung: nomor, huruf besar, simbol and huruf kecil.',
    userCreated: 'Akun berhasil dibuat.',
    clickHereToLogin: 'Klik di sini untuk pergi ke halaman login.',
    usernameExists: '* Nama pengguna sudah dipakai.',
    registrationLinkExpired:
        'Tautan registrasi sudah kedaluwarsa, mohon menghubungi tim support kami.',
    male: 'Laki-laki',
    female: 'Perempuan',
    genderNull: 'Tidak disebutkan',
    gender: 'Jenis Kelamin',
    next: 'Berikutnya',
    back: 'Kembali',
    organizationOrCompany: 'Nama Organisasi / Usaha',
    profit: 'Estimasi Keuntungan',
    npwp: 'NPWP',
    numberOfEmployees: 'Jumlah Karyawan',
    community: 'Berasal dari komunitas manakah usahamu?',
    done: 'Selesai',
    userProfile: 'Profil',
    businessInformation: 'Informasi Usaha',
    accountInformation: 'Informasi Akun',
    finish: 'Selesai',
    tooltipUsername1: '- Minimal 5 karakter.',
    tooltipPassword1: '- Minimal 9 karakter.',
    tooltipPassword2: '- Harus mengandung huruf besar (A-Z).',
    tooltipPassword3: '- Harus mengandung huruf kecil (a-z).',
    tooltipPassword4: '- Harus mengandung angka (0-9).',
    tooltipPassword5: '- Harus mengandung simbol (contoh. !, $, #).',
    organizationNotComplete:
        'Sebelum melakukan transaksi, mohon untuk melengkapi profil usaha Anda',
    alreadyExists: 'sudah digunakan',
    hasCreated: 'sudah terbuat',
    billingStatus: 'Status Tagihan',
    actived: 'Aktif',
    suspended: 'Di Tangguhkan',
    activity: 'Aktivitas',
    documents: 'Dokumen',
    accountSettings: 'Pengaturan Akun',
    logout: 'Keluar',
    from: 'Dari',
    to: 'Sampai Dengan',
    noTaskFound: 'Tidak Ada Tugas Ditemukan',
    success: 'Berhasil',
    minimumRange: 'Rentang Minimum',
    maximumRange: 'Rentang Maksimal',
    createProduct: 'Buat Produk',
    createInventory: 'Buat Inventaris',
    createForm: 'Buat Formulir',
    updateForm: 'Ubah Formulir',
    form: 'Formulir',
    addAnswer: 'Tambahkan Jawaban',
    required: 'Required',
    formName: 'Nama Formulir',
    formDescription: 'Deskripsi Formulir',
    manageForm: 'Kelola Formulir',
    duplicate: 'Duplikat',
    fillForm: 'Isi Form',
    editForm: 'Ubah Jawaban',
    viewForm: 'Lihat Form',
    answerSubmitted: 'Jawaban berhasil disimpan.',
    answer: 'Jawaban',
    keyword: 'Kata Kunci',
    keywords: 'Kata Kunci',
    suspensions: 'Suspensions',
    creditLimitExpiryDate: 'Tanggal Kedaluwarsa Batas Kredit',
    forever: 'Selamanya',
    spesificDate: 'Tanggal Tertentu',
    overdueAmount: 'Overdue Amount',
    dashboard: 'Beranda',
    tasks: 'Tugas',
    administration: 'Administrasi',
    users: 'Pengguna',
    banks: 'Daftar Bank',
    roles: 'Otoritas',
    programs: 'Program',
    contracts: 'Kontrak',
    jobs: 'Pekerjaan',
    file: 'Berkas',
    auditTrail: 'Jejak Audit',
    referenceSourceNav: 'Reference Source',
    reporting: 'Laporan',
    documentReport: 'Laporan Dokumen',
    registeredDate: 'Tanggal Pendaftaran',
    creditType: 'Tipe Kredit',
    bookingOfficeMonitoringTools: 'Laporan Booking Office',
    customerReport: 'Laporan Pelanggan',
    relationDetail: 'Rincian Relasi',
    relation: 'Relasi',
    transactionReport: 'Laporan Transaksi',
    response: 'Respon',
    transferDetailsReference: 'Referensi Detail Transfer',
    statusTransfer: 'Status Transfer',
    fsStatus: 'Fs Status',
    narrative: 'Narrative',
    proposal: 'Proposal',
    transactionType: 'Tipe Transaksi',
    financingReport: 'Laporan Keuangan',
    reportEngine: 'Mesin Laporan',
    moneyMovement: 'Pergerakan Uang',
    createDocument: 'Buat Dokumen',
    quotes: 'Penawaran',
    invoices: 'Invoice',
    accurate: 'Accurate',
    downpayment: 'Down Payment',
    inventory: 'Gudang',
    inventoryReport: 'Laporan Persediaan',
    invoiceSettlement: 'Pelunasan Invoice',
    products: 'Produk',
    contact: 'Hubungi Kami',
    feeTemplate: 'Template Biaya',
    feeManagement: 'Manajemen Biaya',
    chargesPlan: 'Rencana Biaya',
    executionPhaseFee: 'Fase Eksekusi',
    outstanding: 'Belum Lunas',
    invoicedFee: 'Biaya Tagihan',
    cycleFee: 'Siklus',
    nameFee: 'Nama',
    confirmNewPasswordMsg: 'Harap masukkan kembali kata sandi baru Anda',
    feeTemplateDetail: 'Rincian Template Biaya',
    feeName: 'Nama Biaya',
    executionPhase: 'Fase Eksekusi',
    gracePeriod: 'Masa tenggang',
    oneTime: 'Sekali',
    daily: 'Harian',
    weekly: 'Mingguan',
    monthly: 'Bulanan',
    preCharges: 'Pra biaya',
    postCharges: 'Biaya setelah',
    initiate: 'Mulai',
    early: 'Dini',
    extension: 'Perpanjangan',
    late: 'Terlambat',
    tierType: 'Tingkat Jenis',
    static: 'Statis',
    dynamic: 'Dinamis',
    formula: 'Formula',
    copy: 'Salin',
    none: 'Tidak Ada',
    void: 'Kosong',
    postPoned: 'Ditunda',
    // new translation x4-6459
    signup: 'Daftar',
    userNameMinimalValidation: 'Nama Pengguna harus mencapai 5 karakter',
    userNameRequiredValidation: 'Harap mengisi Nama Pengguna!',
    userNameMatchValidation: 'Nama pengguna tidak boleh mengandung simbol khusus\n',
    nameMinimalValidation: 'Nama harus mencapai 5 karakter',
    nameRequiredValidation: 'Harap mengisi Nama!',
    mobileNumberMinimalValidation: 'Nomor Ponsel harus mencapai 10 karakter',
    mobileNumberRequiredValidation: 'Harap mengisi Nomor Ponsel!',
    emailAddressValidation: 'Format alamat surel salah',
    emailAddressRequiredValidation: 'Harap mengisi Alamat Surel!',
    passwordMinimalValidation: 'Kata Sandi harus mencapai 9 karakter',
    passwordMatchValidation:
        'Kata Sandi harus mengandung: nomor, huruf besar, huruf khusus and huruf kecil\n',
    passwordRequiredValidation: 'Harap mengisi Kata Sandi!',
    confirmPassValidation: 'Kata Sandi harus sama',
    confirmPassRequiredValidation: 'Konfirmasi Kata Sandi dibutuhkan',
    captchaRequiredValidation: 'Harap mengisi Captcha!',
    registerSuccessMessage:
        'Nama pengguna dapat diverifikasi setelah pengajuan dan captcha diperbarui jika nama pengguna sudah terpakai',
    createAccountSuccessMessage: 'Berhasil untuk membuat akun',
    hoverInformation: 'Arahkan kursor ke ',
    hoverDescription: ' ikon untuk melihat jumlah desimal penuh',
    available: 'Tersedia',
    completed: 'Selesai',
    transactionWidget: 'Transaksi',
    overdueTab: 'Terlambat',
    outstandingTab: 'Tagihan',
    transactionValue: 'Nilai Transaksi Teratas',
    viewFullList: 'lihat daftar lengkap',
    maximum: 'Maksimum',
    all: 'Semua',
    upcomingSettlements: 'Pelunasan Akan Datang',
    participantName: 'Nama Partisipan',
    number: 'Angka',
    financingOverview: 'Ringkasan Pembiayaan',
    balanceWidget: 'Laporan Saldo',
    verifyEmail: 'Verifikasi Email',
    inventoryList: 'Daftar inventaris',
    inventoryDetail: 'Detail Inventaris',
    inventoryDetailByDate: 'Detail Inventaris Per Tanggal',
    roleAdd: 'Tambah Peran',
    roleEdit: 'Ubah Peran',
    createUserProfile: 'Buat Profil Pengguna',
    editUserProfile: 'Ubah Profil Pengguna',
    editUser: 'Ubah Pengguna',
    createOrganization: 'Buat Organisasi',
    editOrganization: 'Ubah Organisasi',
    createCalendar: 'Buat Kalender',
    editCalendar: 'Ubah Kalender',
    createAuthorization: 'Buat Otorisasi',
    editAuthorization: 'Ubah Otorisasi',
    organizationAuthDetail: 'Detail Otorisasi Organisasi',
    createSales: 'Buat Penjualan',
    editSales: 'Ubah Penjualan',
    fileExport: 'Ekspor File',
    auditTrailDetail: 'Rincian Audit',
    // new translation x4-6459
    noAttachmentAdded: 'Tidak ada lampiran yang ditambahkan.',
    statusHistory: 'Riwayat Status',
    currentState: 'Kondisi Saat Ini',
    exemption: 'Dispensasi',
    totalDataSelected: 'Total data dipilih : ',
    creditLimitExpiryDateRemark:
        'Fasilitas limit credit sudah expired, tolong perbaharui dengan menghubungi funder',
    creditLimitModal: 'Fasilitas kredit untuk organisasi ini sudah expired, lanjutkan ?',
    upfrontBilling: 'Penagihan di Muka',
    bypassFunder: 'Lewati Penyandang Dana',
    originAccount: 'Akun Asal',
    destinationAccount: 'Akun Tujuan',
    bulkFinancing: 'Bulk Financing',
    fundAllocation: 'Alokasi Dana',
    fundAllocationRateBelow100: 'Alokasi persentase harus 100%.',
    fundAllocationRateAbove100: 'Alokasi persentase harus 100%.',
    fundAllocationOriginEmpty: 'Silakan pilih Akun Asal.',
    fundAllocationDestinationEmpty: 'Silakan pilih Akun Tujuan.',
    fundAllocationSubmitted: 'Alokasi dana disimpan.',
    amortizationDate: 'Tanggal Amortisasi',
    amortizationHistory: 'Riwayat Amortisasi',
    amortizationAmount: 'Jumlah Amortisasi',
    addProperty: 'Tambahkan properti.',
    valueType: 'Tipe nilai',
    extensionRequest: 'Permintaan ekstensi',
    extensionTenor: 'Tenor ekstensi',
    activation: 'Pengaktifan',
    feeSettings: 'Pengaturan Biaya',
    settlementExtension: 'Ekstensi Pelunasan',
    settlementExtensionSetting: 'Pengaturan Ekstensi Pelunasan',
    addRabate: 'Tambah Pendapatan Bersama',
    rabate: 'Pendapatan Bersama',
    rabateSetting: 'Pengaturan Pendapatan Bersama',
    rebateTiering: 'Pengaturan Pendapatan Bersama',
    vatPercentage: 'Persentase PPN',
    bulkExtension: 'Ekstensi Massal',
    bulkExtensionRequestForm: 'Form Ekstensi',
    settlementExtensionRequestForm: 'Form Perpanjangan Pelunasan',
    selectedDocuments: 'Dokumen yang dipilih',
    extensionDueDate: 'Tanggal Jatuh Tempo Perpanjangan',
    extensionHistory: 'Riwayat Perpanjangan',
    extensionFee: 'Biaya Perpanjangan',
    settlementExtensionDueDate: 'Tanggal Jatuh Tempo Perpanjangan Pelunasan',
    settlementExtensionHistory: 'Riwayat Perpanjangan Pelunasan',
    settlementExtensionFee: 'Biaya Perpanjangan Pelunasan',
    settlementExtensionTenor: 'Jangka Waktu Perpanjangan Pelunasan',
    dueDateLessThanMaturityDate:
        'Tanggal jatuh tempo pelunasan harus lebih dari tanggal jatuh tempo.',
    pickDate: 'Klik untuk memilih tanggal...',
    'com.asyx.x4.finprocess.extension.not_found.financing_statement':
        'Financing Statement tidak ditemukan.',
    'com.asyx.x4.finprocess.extension.invalid_tag':
        'Status / tag tidak valid. Status / tag yang diizinkan DISBURSED / EXTENDED.',
    'com.asyx.x4.finprocess.extension.invalid_disbursement': 'Pencairan tidak ditemukan.',
    'com.asyx.x4.finprocess.extension.multi_payment_date':
        'Tidak dapat memproses pernyataan pembiayaan dengan Tanggal Pencairan Multi Pembayaran.',
    'com.asyx.x4.finprocess.extension.multi_financing_tenor':
        'Tidak dapat memproses pernyataan pembiayaan dengan Multi Pembiayaan Tenor of Disbursement.',
    'com.asyx.x4.finprocess.extension.multi_tag':
        'Tidak dapat memproses pernyataan pembiayaan dengan status yang berbeda.',
    'com.asyx.x4.finprocess.extension.multi_contract':
        'Tidak dapat memproses pernyataan pembiayaan dengan kontrak yang berbeda.',
    'com.asyx.x4.finprocess.extension.multi_recourse':
        'Tidak dapat memproses pernyataan pembiayaan dengan recourse yang berbeda.',
    'com.asyx.x4.finprocess.extension.multi_currency':
        'Tidak dapat memproses pernyataan pembiayaan dengan mata uang yang berbeda.',
    'com.asyx.x4.finprocess.extension.not_found.contract_participant_stage':
        'Tahap peserta kontrak tidak ditemukan.',
    'com.asyx.x4.finprocess.extension.restriction.extension_tenor':
        'Ekstensi tenor lebih dari jangka waktu yang diperpanjang maksimum.',
    'com.asyx.x4.finprocess.extension.restriction.invalid_due_date':
        'Extension due date should be less than maximum extended tenor or remaining tenor.',
    'com.asyx.x4.finprocess.extension.waiting_approval.extension':
        'Tidak dapat meminta ekstensi karena dokumen sedang menunggu persetujuan atau sudah diperpanjang.',
    extensionRequested: 'Permintaan ekstensi dikirimkan.',
    settlementExtensionRequested: 'Permintaan ekstensi pelunasan dikirimkan.',
    'com.asyx.x4.finprocess.extension.restriction.deselect_all':
        'Silakan pilih setidaknya satu pernyataan pembiayaan, atau tolak tugas sebagai gantinya.',
    'com.asyx.x4.finprocess.extension.restriction.unregistered_financing_statement':
        'Pernyataan pembiayaan tidak terdaftar.',
    'com.asyx.x4.finprocess.extension.restriction.tenor_exceed': 'Tenor melebihi maksimal',
    'com.asyx.x4.organizationFreeze':
        'Organisasi Telah Dibekukan. Silakan periksa Tanggal Jatuh Tempo Kredit / Kolektabilitas Kredit / Faktur yang telah Jatuh Tempo ke Bank. Silahkan hubungi Administrator Bank.',
    'com.asyx.x4.contractFreeze':
        'Kontrak telah dibekukan, Akumulasi Pencairan Kredit / Akumulasi Jumlah Hari yang telah Jatuh Tempo ke Bank melewati ambang batas ketentuan. Silahkan hubungi Administrator Bank.',
    extensionDetail: 'Detail ekstensi',
    settlementExtensionDetail: 'Detail ekstensi penyelesaian',
    extensionID: 'ID Ekstensi',
    extendedDueDate: 'Ekstensi tanggal jatuh tempo',
    extensionType: 'Tipe Ekstensi',
    transferDetails: 'Detail Transfer',
    retry: 'Ulangi',
    retryBookingOffice: 'Ulangi Booking Office',
    bookingOfficeExecutionHistory: 'Riwayat Eksekusi Booking Office',
    lastExecutionStartTime: 'Waktu mulai eksekusi terakhir',
    lastExecutionEndTime: 'Waktu akhir eksekusi terakhir',
    duration: 'Durasi',
    executions: 'Eksekusi',
    executedBy: 'Dieksekusi oleh',
    beginningStatus: 'Status awal',
    endStatus: 'Status Akhir',
    executionDateTime: 'Tanggal & Waktu Eksekusi',
    deliveryLocation: 'Lokasi Pengiriman',
    expetedInvoiceMaturityDate: 'Tanggal Jatuh Tempo Faktur yang Diharapkan',
    descriptionNull: 'Mohon untuk mengisi item dahulu.',
    totalAssetPercentage: 'Persentase Total Aset',
    transactionInquiry: 'Inkuiri Transaksi',
    periodInquiry: 'Periode',
    beginningBalance: 'Saldo awal',
    totalDebit: 'Jumlah Debit',
    totalCredit: 'Jumlah Kredit',
    postDate: 'Tanggal Posting',
    journalNo: 'Nomor Jurnal',
    debitOrCredit: 'Db/Cr',
    balance: 'Saldo',
    configurationTools: 'Alat Konfigurasi',
    participant: 'Partisipan',
    parameterType: 'Tipe Parameter',
    freezed_account: 'Akun dibekukan',
    unfreezed_account: 'Akun tidak dibekukan',
    proposal_after_office_hour: 'Proposal setelah jam kantor',
    manual_proposal_creation: 'Penciptaan proposal manual',
    without_transfer_approval: 'Tanpa persetujuan transfer',
    credit_limit_expired_date: 'Batas Kredit Tanggal Kedaluwarsa',
    vatNull: 'Mohon untuk mengisi VAT dahulu',
    expectedInvoiceMaturityDate: 'Tanggal Jatuh Tempo Faktur yang Diharapkan',
    pageNumber: 'Nomor Halaman',
    dateFrom: 'Tanggal Awal',
    dateTo: 'Tanggal Akhir',
    outstandingTransactions: 'Outstanding Transactions',
    fscmOutstanding: 'FSCM Outstanding',
    iconsOutstanding: 'iCons Outstanding',
    addDocumentLink: 'Mengaitkan Dokumen',
    documentLink: 'Document Terkait',
    selectOrder: 'Memillih Pesanan',
    financingAfterCutOffTime: 'Pembiayaan setelah waktu cut off',
    rowsPerPage: 'Baris per halaman',
    payFees: 'Pay Fees',
    cifNumber: 'Nomor CIF',
    branchInformation: 'Cabang',
    synchronize: 'Synchronize',
    yes: 'Ya',
    not: 'Tidak',
    ok: 'Ok',
    syncOrganizationConfirmationTitle: 'Sinkronkan Data Organisasi',
    syncOrganizationConfirmationMessage: 'Apakah Anda ingin menyinkronkan data organisasi ini?',
    synchronizeSuccessMessage: 'Data berhasil disinkronkan.',
    bulkSyncOrganizationConfirmationMessage: 'Apakah Anda ingin menyinkronkan data organisasi ini?',
    failed: 'Gagal',
    result: 'Hasil',
    reason: 'Alasan',
    'com.asyx.x4.uoa.synchronize.failed.not_deposit': 'Tipe akun bukan akun deposit.',
    'com.asyx.x4.uoa.synchronize.failed.not_available': 'Nomor akun tidak tersedia.',
    'com.asyx.x4.uoa.synchronize.failed.no_giro': 'Organisasi ini tidak memiliki akun giro.',
    syncContractConfirmationTitle: 'Sinkronkan Data Kontrak',
    syncContractConfirmationMessage: 'Apakah Anda ingin menyinkronkan data kontrak ini?',
    bulkSyncContractConfirmationMessage: 'Apakah Anda ingin menyinkronkan data kontrak ini?',
    'com.asyx.x4.finconfig.synchronize.failed.account_number_not_found':
        'Organisasi tidak memiliki nomor akun.',
    'com.asyx.x4.finconfig.synchronize.failed.no_data_from_icons':
        'Tidak ada respons dari iCons, nomor CIF kemungkinan tidak valid.',
    'com.asyx.x4.finconfig.synchronize.failed.contract_participant_not_found':
        'Kontrak partisipan tidak ditemukan.',
    bulkSettleConfirmation: 'Bulk settle confirmation',
    bulkSettleConfirmationMsg: 'Perbedaannya tidak sama dengan nol',
    bulkSettleConfirmationDetail:
        '* Jika Anda ingin melanjutkan proses ini, silakan klik tombol di bawah ini',
    'login.invalidUsernamePassword': 'Nama pengguna/kata sandi anda salah.',
    'login.expiredPassword': 'Kata sandi anda sudah expired, silakan hubungi administrator.',
    'login.accountLocked': 'Akun anda terkunci, silakan hubungi Administrator',
    'login.generalFailure': 'Gagal terhubung ke server, mohon mencoba kembali.',
    welcomeText: 'Selamat datang di ASYX X4',
    welcome: 'Selamat Datang di Layanan ',
    bniService: 'BNIdirect Supply Chain',
    loginToYourAccount: 'Masuk ke Akun Anda',
    checkMail: 'Periksa email Anda',
    resetPasswordInstructionMsg: 'Kami telah mengirimkan instruksi reset kata sandi ke email Anda.',
    'com.asyx.x4.invalid_captcha': 'Captcha tidak sesuai.',
    serverStatus: 'Status Server',
    bniContactUs: 'Hubungi Kami',
    bniWelcomeText: 'Selamat datang di layanan BNI FSCM',
    creditDebitNote: 'Catatan Kredit/Debit',
    others: 'Lainnya',
    bniRedirectErrorMsg: 'Silahkan redirect kembali, session anda telah habis.',
    bniRedirectManualLogin: 'Masuk secara manual di sini',
    bniRedirectSuccessMsg: 'Berhasil masuk, kami akan segera mengarahkan Anda ke portal...',
    bniRedirectSuccessManual: 'Klik di sini jika Anda belum diarahkan ke portal dalam 5 detik.',
    bulkSettlement: 'Bulk Settlement',
    acceptTask: 'Konfirmasi Tugas',
    bulkSettlementConfirmation: 'Lanjutkan bulk settlement dengan dokumen-dokumen ini?',
    bulkAcceptTaskApiConfirmation: 'Lanjutkan proses tugas dengan dokumen-dokumen ini?',
    bulkSettlementFailed: 'Proses bulk settlement gagal.',
    bulkAcceptTaskApiFailed: 'Proses task gagal.',
    'com.asyx.x4.finprocess.settlement.invalid-size':
        'Jumlah dokumen yang dipilih harus setidaknya 1 atau kurang dari atau sama dengan 100 dokumen.',
    'com.asyx.x4.finprocess.settlement.create.invalid-status':
        'Hanya Financing Statement dengan status DISBURSED, PARTLY SETTLED, EXTENDED atau SETTLEMENT EXTENDED yang diperbolehkan untuk diproses.',
    'com.asyx.x4.finprocess.settlement.edit.invalid-status':
        'Financing Statement yang dipilih harus memiliki status PENDING SETTLEMENT.',
    'com.asyx.x4.finprocess.settlement.invalid-currency':
        'Financing Statement yang dipilih harus memiliki mata uang yang sama.',
    'com.asyx.x4.finprocess.settlement.invalid-relation':
        'Financing Statement yang dipilih harus memiliki hubungan organisasi yang sama.',
    'com.asyx.x4.finprocess.settlement.invalid-payment-date':
        'Financing Statement yang dipilih harus memiliki tanggal pembayaran pencairan yang sama.',
    'com.asyx.x4.uoa.organization.failed-delete':
        'Data ini sedang digunakan di tabel atau entitas lain.',
    'com.asyx.x4.organization.used':
        'Gagal hapus organisasi, organisasi sudah memiliki kontrak. Mohon periksa kembali.',
    'com.asyx.x4.constraint': 'Organisasi tersebut telah terhubung dengan Otorisasi.',
    uploadSettlement: 'Unggah Pembayaran',
    FinancingStatementReference: 'Financing Statement Reference',
    RepaymentDate: 'Repayment Date',
    RepaymentAmount: 'Repayment Amount',
    ResidualTransferDate: 'Residual Transfer Date',
    level: 'Level',
    showApprovers: 'Lihat pemberi persetujuan',
    approver: 'Pemberi Persetujuan',
    help: 'Bantuan',
    helpBookingOffice:
        'Booking Office adalah fitur berfungsi untuk menjalankan transaksi dengan integrasi pada Icon. Pengguna dapat melakukan aktivasi pembukuan menggunakan integrasi Icon dengan mengaktifkan toogle yang tersedia (Pencairan, Pelunasan atau keduanya).',
    helpErrorMsg: 'Gagal mengunduh dokumen bantuan, klik untuk mencoba lagi',
    childs: 'Anak Perusahaan',
    limitSettings: 'Konfigurasi Limit',
    followsContractLimit: 'Mengikuti Limit Kontrak',
    limitAllocation: 'Alokasi Limit',
    allocationPercentage: 'Persentase Alokasi',
    allocationPercentageValidation: 'Total alokasi tidak boleh melebihi 100%',
    exports: 'Ekspor file',
    propertyConfiguration: 'Konfigurasi Properti',
    penalties: 'Pinalti',
    outstandingParameters: 'Parameter Pengeluaran',
    disbursementPhases: 'Fase Disbursement Phases',
    settlementPhases: 'Fase Settlement Phases',
    settlementExtensionPhases: 'Fase Settlement Extension',
    accounts: 'Akun',
    generalLedgerSf: 'Booking GL SF Setting',
    generalLedgerDf: 'Booking GL DF Setting',
    generalLedgerSd: 'Booking GL SD Setting',
    data: 'Data',
    message: 'Event',
    auditTags: 'Jenis',
    timestamp: 'Waktu',
    reconciliationReport: 'Laporan Rekonsiliasi',
    totalResiduals: 'Total Residuals',
    adjustmentBankCharges: 'Penyesuaian - Bank Charges',
    adjustmentCreditNote: 'Penyesuaian - Credit Note',
    adjustmentOthers: 'Penyesuaian - Others',
    process: 'Proses',
    ipAddress: 'Alamat IP',
    field: 'Field',
    before: 'Sebelum',
    after: 'Setelah',
    eventDetail: 'Detail Event',
    noAdditionalData: 'Tidak ada data tambahan',
    holidayList: 'Jadwal Libur',
    holidayFinancingStatement: 'Pernyataan Pembiayaan Liburan',
    emptyExclusions: '* Harap berikan tanggal pada setiap tanggal pengecualian',
    downloadTemplate: 'Unduh Template',
    uploadOrganizationCalendar: 'Upload Organization Calendar',
    fileSelected: 'File dipilih',
    fileUploaded: 'File berhasil diupload.',
    autoSettlementDetails: 'Detail Pelunasan Otomatis',
    deleteCalendar: 'Hapus Kalender',
    oldData: 'Data lama',
    newData: 'Data baru',
    cannotDeletePastDate: 'Tanggal masa lalu atau hari ini tidak dapat dihapus.',
    checkNetPlafond: 'Check Net Plafond',
    invoiceList: 'Daftar Invoice',
    'com.asyx.x4.document.duplicate_invoice_reference':
        'Tidak dapat memperbarui dokumen, ada referensi duplikat.',
    invoiceApproval: 'Persetujuan Invoice',
    documentInformation: 'Informasi Dokumen',
    invoiceApprovalEditFirst: 'Anda harus mengklik tombol Edit terlebih dahulu.',
    referenceAlreadyExist: 'Reference sudah terdaftar pada sistem.',
    invalidReference: 'Reference tidak valid.',
    fileTooLarge: 'Maksimum ukuran file 50 MB',
    checking: 'Memeriksa...',
    calendarDateAlreadyExist: 'Tanggal kalender sudah ada, Silakan memilih tanggal lain.',
    otpSmsForm: 'One Time Password SMS',
    otpEmailForm: 'One Time Password Email',
    'com.asyx.x4.invoices.exceeds_limit': 'Total Faktur melebihi limit yang tersedia',
    automaticDisbursement: 'Pencairan Otomatis',
    passwordUpdated: 'Kata sandi Anda berhasil diubah.',
    otpSent: 'Kode OTP telah dikirim ke ',
    pleaseVerifyOtpBelow: ', harap verifikasi di bawah ini.',
    didNotReceiveOtp: 'Tidak menerima kode OTP?',
    resendOtp: 'Kirim ulang OTP',
    verifyOtp: 'Verifikasi OTP',
    'com.asyx.x4.incorrect_otp': 'Kode OTP salah.',
    jobExecutionEnabled: 'Aktifkan Eksekusi Job',
    addConfiguration: 'Add Configuration',
    normalPaymentValue: 'Normal Payment Value',
    bulkExtensionError:
        'Bulk Extension belum dikonfigurasi untuk transaksi ini, silakan periksa kontrak Anda atau hubungi administrator.',
    bulkSettlementExtensionError:
        'Settlement Extension belum dikonfigurasi untuk transaksi ini, silakan periksa kontrak Anda atau hubungi Administrator.',
    chooseDate: 'Klik untuk memilih tanggal...',
    maxFileSize: 'Ukuran maksimum file',
    onlyAcceptFileType: 'Hanya menerima tipe file:',
    plafond: 'Plafond',
    disponible: 'Disponible',
    holdAmount: 'Hold Amount',
    netPlafond: 'Net Plafond',
    loadingCaptcha: 'Memuat captcha...',
    reloadCaptcha: 'Request captcha baru',
    enterCaptcha: 'Masukkan captcha',
    reloadCaptchaDelay: 'detik sebelum bisa request captcha baru.',
    tools: 'Tools',
    activityTools: 'Activity Tools',
    activityHistory: 'Activity History',
    submitDuplicateMessage: 'Mohon untuk melakukan pemeriksaan kembali item berikut',
    submitDuplicate: 'Konfirmasi Duplikat',
    collaborationCreditLimit: 'Batas Kredit Kolaborasi',
    rateChanges: 'Rate Changes',
    uploadRate: 'Upload Rate',
    referenceRatePercentage: 'Reference Rate Percentage',
    funderSpreadPercentage: 'Funder Spread Percentage',
    sharedRevenuePercentage: 'Shared Revenue Percentage',
    brokerFeePercentage: 'Broker Fee Percentage',
    technologyFeePercentage: 'Technology Fee Percentage',
    processingFeePercentage: 'Processing Fee Percentage',
    collectionFeePercentage: 'Collection Fee Percentage',
    commissionFeePercentage: 'Commission Fee Percentage',
    othersFeePercentage: 'Others Fee Percentage',
    financingStatement: 'Financing Statement',
    rateChangeApproval: 'Rate Change Approval',
    changeDate: 'Tanggal Berubah',
    quoteRestriction: 'Quote Restriction',
    quoteRestrictionDays: 'Quote Restriction Days',
    announcement: 'PEMBERITAHUAN',
    quoteRestrictionChecking: 'Mohon tunggu, melakukan pengecekan restriksi quote.',
    contractNameEmpty: 'Missing information: Contract Name!',
    currencyContractLimitSettingEmpty: 'Please select Currency on Limit Contract Setting!',
    maximumCreditLimitOnContractExceed: 'The Maximum Credit Limit is too large!',
    maximumCreditLimitContractEmpty: 'Missing information: Maximum Credit Limit!',
    overridePercentageContractEmpty: 'Missing information: Override Percentage!',
    optionRatesCurrencyEmpty: 'Please select Currency on Number of Days Divisor!',
    optionRatesDivisorEmpty: 'Please select Divisor on Number of Days Divisor!',
    proposalRejectionDaysEmpty: 'Missing information: Proposal Rejection Days!',
    minimumFinancingTenorEmpty: 'Missing information: Minimum Financing Tenor!',
    signatureMessage:
        'Dengan ini kami menyatakan bahwa kami menyetujui rincian Proposal Pembiayaan ini.',
    changeAppLogo: 'Ganti Logo Aplikasi',
    resetAppLogo: 'Reset Logo',
    changeLogo: 'Ganti Logo',
    serviceActionTeam: 'Service Action Team (SAT)',
    transactionPin: 'PIN Transaksi',
    updateTransactionPin: 'Perbarui PIN',
    enterCurrentPin: 'Masukan PIN anda saat ini.',
    enterNewPin: 'Masukan PIN baru anda.',
    confirmNewPinMsg: 'Masukan ulang PIN baru anda.',
    validationUpdatePinMessage: '* PIN harus terdiri dari minimal 6 angka',
    pinDidNotMatch: '* * Konfirmasi PIN tidak sama.',
    blockPin: 'Block PIN',
    unblockPin: 'Unblock PIN',
    pinVerification: 'Verification',
    forgotPin: 'Forgot PIN ?',
    successForgotPin: 'Successfully forgot PIN, please check your email.',
    pinUpdated: 'PIN Anda berhasil diubah.',
    createPin: 'Create PIN',
    pleaseInputPin: 'Enter your 6-digit Transaction PIN',
    vietnam: 'Vietnam',
    overpayment: 'Overpayment',
    underpayment: 'Underpayment',
    pph23: 'PPH23',
    amountDue: 'Amount Due',
    b2bPayment: 'Payment',
    taskDetailEditInformation: 'Mohon untuk meninjau dan menyetujui detail dokumen',
    totalSettlementAmount: 'Jumlah Total Pembayaran',
    fundAvailable: 'Dana Tersedia',
    pranota: 'Pra Nota',
    receivedDate: 'Tanggal Diterima',
    uploadPraNota: 'Upload Pra Nota',
    pleaseSelectCommisionRateCurrency: 'Mohon pilih Mata Uang pada Pengaturan Commission Rate!',
    pleaseSelectReferenceRateCurrency: 'Mohon pilih Mata Uang pada Pengaturan Reference Rate!',
    pleaseSelectRebateCurrency: 'Mohon pilih Mata Uang pada Pengaturan Rebate!',
    principal: 'Principal',
    linkedDocumentInformation: 'Informasi Dokumen Terkait',
    referenceDate: 'Reference Date',
    giroAccountMissing: 'Please set Giro Account to Recourse Configuration!',
    contractNotFoundBuyer: 'Kontrak tidak ditemukan untuk kode pembeli',
    andSupplier: 'dan kode penjual',
    currencyFor: 'Mata Uang',
    isIrrelevantExistingContract: 'tidak ditemukan',
    isIrrelevantExistingContractCurrency: 'wajib diisi',
    for: 'yang',
    shouldContainValue: 'wajib diisi',
    lengthBetween5and50: 'Nomor Faktur harus terdiri dari 5 sampai 50 karakter',
    shouldPositiveAmount: 'harus memiliki nominal positif',
    isInvalidReference: 'nomor Faktur tidak valid',
    rowCannotEmpty: 'Baris data tidak diperbolehkan kosong',
    cannotNegativeValue: 'nominal tidak boleh negatif',
    cannotMoreThan100: 'tidak boleh lebih dari 100',
    cannotFutureDate: 'tidak boleh merupakan tanggal yang akan datang',
    cannotLessThan: 'tidak boleh kurang dari',
    cannotLessThanToday: 'tidak boleh kurang dari hari ini',
    lengthShouldLessThan255Characters: 'panjangnya harus kurang dari 255 karakter',
    formatCNDNincorrect:
        'format tidak sesuai, Jumlah CN / DN hanya boleh angka, tidak ada karakter atau simbol yang diizinkan',
    formatRTRNincorrect:
        'format tidak sesuai, Jumlah RTRN hanya boleh angka dan selalu dalam nominal negatif, tidak ada karakter atau simbol yang diizinkan kecuali -',
    formatARincorrect:
        'format tidak sesuai, Jumlah AR hanya boleh angka dan selalu dalam nominal positif, tidak ada karakter, simbol, atau jumlah negatif yang diizinkan',
    formatIncorrect: 'format tidak sesuai',
    amountShouldNumeric: 'nominal hanya boleh angka, tidak diperkenankan simbol dan angka negatif',
    totalAmountMoreThanZero: 'Total nominal harus lebih dari nol, referensi',
    withTotalAmount: 'dengan total nominal',
    shouldMore5And365days: 'Jangka waktu pembayaran wajib lebih dari 0 dan kurang dari 365 hari',
    activeOrganizationNotRelevant:
        'Organisasi aktif tidak relevan dengan data organisasi pada baris tersebut',
    formatIncorect: 'format tidak sesuai',
    maximumFinancingTenorValidation:
        'Tanggal Jatuh Tempo harus kurang dari Jangka Waktu Pembiayaan Maksimum!',
    maximumCreditLimitValidation: 'Nominal harus kurang dari Batas Kredit Maksimum!',
    formatIsNotCorrect: ' ',
    shouldBeYYYYMMDD: 'dalam bentuk YYYYMMDD',
    amountFormatIncorect: 'Format',
    invoiceCode: 'Nomor Faktur',
    invoiceamount: 'Nominal',
    numberToDate: 'Jangka Waktu Pembayaran',
    null: 'kosong',
    Currency: 'Mata Uang',
    maximalAmountMsg:
        'Jumlah nominal melebihi batas sistem. Harap periksa dan pastikan tidak melebihi 15 digit.',
    shortMaximalAmountMsg: 'Jumlah nominal tidak boleh lebih dari 15 digit',
    shortMaximalAmountRowMsg: 'Nominal tidak boleh lebih dari 15 digit',
    invoicereference: 'Nomor Faktur',
    invoicecurrency: 'Mata Uang Faktur',
    invoicedate: 'Tanggal Faktur',
    format: 'Format',
    receiveddate: 'Tanggal Diterima',
    amortization: 'Amortisasi',
    pendingTaskList: 'Pending Task List',
    approvalApi: 'Approval API',
    addNewParticipant: 'Tambah Partisipan Baru',
    'com.asyx.x4.pendingtask.reject.error': 'Gagal menolak Tugas.',
    hideMenu: 'Sembunyikan Menu',
    yourAccesUrl: 'Pastikan alamat yang Anda akses adalah',
    createInvoiceFreezeMsg:
        'Tidak dapat membuat dokumen dikarenakan kontrak sedang dibekukan. Silakan hubungi administrator Anda untuk bantuan lebih lanjut.',
    uploadInvoiceFreezeMsg:
        'Tidak dapat mengunggah dokumen dikarenakan kontrak sedang dibekukan untuk organisasi ',
    pendingTasks: 'Tugas Tertunda',
    maturity_date_should_less_max_tenor:
        'Tanggal jatuh tempo harus kurang dari Tenor Pembiayaan Maksimum!',
    disponible_amount_exceed: 'Total Faktur melebihi disponible yang tersedia',
    net_plafond_exceed: 'Total Faktur melebihi net plafond yang tersedia',
    bifastErrorMsg:
        'Nominal Invoice harus di antara 1 hingga 250.000.000 untuk metode pembayaran BIFast pada Invoice ',
    llgErrorMsg:
        'Nominal Invoice harus di antara 1 hingga 1.000.000.000 untuk metode pembayaran LLG pada Invoice ',
    rtgsErrorMsg:
        'Nominal Invoice harus di atas 1.000.000.000 untuk metode pembayaran RTGS pada Invoice ',
    ben: 'BEN',
    our: 'OUR',
    counterpart: 'Counterpart',
    contract: 'Kontrak',
    select: 'Pilih...',
    'com.asyx.x4.notification.counterpart_not_allowed':
        'Fitur counterpart tidak bisa digunakan untuk event notifikasi ini',
    'com.asyx.x4.notification.should_general_contract':
        'Kontrak yang dipilih seharusnya bersifat umum / general.',
    'com.asyx.x4.notification.contract_already_exist':
        'Template dengan kontrak, event dan tipe yang sama sudah ada.',
    'com.asyx.x4.notification.template_already_exist': 'Template dengan event yang sama sudah ada.',
    invoicesCannotLessThanToday:
        'Invoice dengan tanggal sebelum hari ini tidak dapat diunggah. Pastikan tanggal invoice adalah hari ini atau di masa mendatang',
    autoRetrySettlement: 'Pelunasan Ulang Otomatis',
    retrySettlement: 'Pelunasan Ulang',
    time: 'Waktu',
    accountBalance: 'Saldo Akun',
    specificResponse: 'Respon Spesifik',
    'com.asyx.x4.notification.event_name_empty':
        'Kolom Events tidak boleh kosong. Silakan pilih atau masukkan events yang sesuai.',
    'com.asyx.x4.notification.template_type_empty':
        'Kolom Type tidak boleh kosong. Silakan pilih atau masukkan type yang sesuai.',
    'com.asyx.x4.notification.template_subject_empty':
        'Kolom Subject tidak boleh kosong. Silakan pilih atau masukkan subject yang sesuai.',
    'com.asyx.x4.notification.template_content_empty':
        'Kolom Content tidak boleh kosong. Silakan pilih atau masukkan content yang sesuai.',
    announcementManagement: 'Pengumuman',
    announcementDetail: 'Detail Pengumuman',
    title: 'Judul',
    active: 'Aktif',
    intervalSpeed: 'Kecepatan Interval',
    'com.asyx.x4.notification.cannot_delete_active_announcement':
        'Tidak dapat menghapus pengumuman yang aktif.',
    'com.asyx.x4.notification.announcement_with_that_uuid_is_not_found':
        'Pengumuman dengan UUID tersebut tidak ditemukan.',
    'com.asyx.x4.notification.title_empty': 'Judul kosong, Harap masukkan judul yang sesuai.',
    'com.asyx.x4.notification.description_empty':
        'Deskripsi kosong, Harap masukkan deskripsi yang sesuai.',
    'com.asyx.x4.notification.interval_speed_empty':
        'Kecepatan interval kosong, Harap masukkan kecepatan interval yang sesuai.',
    'com.asyx.x4.notification.interval_speed_invalid':
        'Kecepatan interval tidak valid, harus antara 1 dan 25.',
    'com.asyx.x4.notification.active_announcement_already_exist':
        'Pengumuman aktif sudah ada, Hanya satu pengumuman aktif yang diperbolehkan.',
    'com.asyx.x4.notification.title_announcement_already_exist':
        'Pengumuman dengan judul yang sama sudah ada, Harap masukkan judul yang berbeda.',
    'com.asyx.x4.notification.asset_status_should_available':
        'Tidak dapat menghapus invoice dengan status asset unavailable.',
    'com.asyx.x4.document.max15digit_totalAmount':
        'Jumlah nominal melebihi batas sistem. Harap periksa dan pastikan tidak melebihi 15 digit.',
    announcementCreated: 'Pengumuman berhasil di buat.',
    announcementUpdated: 'Pengumuman berhasil di ubah.',
    announcementDeleted: 'Announcement berhasil di hapus.',
    searchByTitleOrDecription: 'Cari dengan judul atau deskripsi.',
    deleteInvoice: 'Hapus Invoice',
    'com.asyx.x4.finprocess.settlement.invalid-settlement-transfer-approval':
        'Financing Statements yang dipilih harus memiliki nilai yang sama untuk settlement transfer approval.',
    fileSizeInfo: 'File Size',
    maximumTotalAttachmentFiles: 'Jumlah total file lampiran maksimum harus 5 file.',
    maximumTotalAttachmentFilesSize: 'File berikut melampaui batas ukuran maksimum 20MB.',
    combineRecourse: 'Combine Recourse',
    successUpload: 'Lampiran berhasil diunggah!',
    attachmentFailedFormat: `Nama File tidak boleh menggunakan < & > % $; : ( ) *`,
    attachmentMaximalSize: 'File berikut melebihi ukuran maksimum 20mb.',
    referenceShouldNotContainSpaces: 'Referensi tidak boleh mengandung spasi',
    numberNotAllowedOnFees:
        'Fee dengan type number tidak didukung. harap melalukan pilihan di percentage/amount',
    LLG: 'LLG',
    SHARED_REVENUE: 'Shared Revenue',
    DISBURSEMENT_AMOUNT: 'Disbursement Amount',
    BANK_CHARGE: 'Bank Charge',
    TRANSACTION_FEE: 'Transaction Fee',
    TECHNOLOGY_FEE: 'Technology Fee',
    RTGS: 'RTGS',
    OTHERS_FEE: 'Others Fee',
    PRINCIPAL: 'Principal',
    COMMISSION_FEE: 'Commission Fee',
    OFFSETTING_FEE: 'Offsetting Fee',
    REFERENCE_AMOUNT: 'Reference Amount',
    RABATE: 'Rebate',
    PROCESSING_FEE: 'Processing Fee',
    PROVISION_FEE: 'Provision Fee',
    SPREAD: 'Spread',
    BROKER_FEE: 'Broker Fee',
    COLLECTION_FEE: 'Collection Fee',
    amortizationDetail: 'Detail Amortisasi',
    deleteInvoiceProcess: 'Proses penghapusan invoice ',
    isAlreadyExist: 'sudah ada!',
    realTimeTransaction: 'Pencairan Real-time',
    realTimeConstraints: 'Batasan Real-time',
    end: 'End',
    idleTime: 'Idle Time (HH:MM:SS)',
    'com.asyx.x4.contract.approval_more_than_one': 'Approval tidak bisa lebih dari 1.',
    matrixCreated: 'Matriks Persetujuan telah dibuat.',
    matrixUpdated: 'Matriks Persetujuan telah diperbarui.',
    'com.asyx.x4.invoices.exceeds_tenor':
        'Tanggal Jatuh Tempo harus kurang dari Jangka Waktu Pembiayaan Maksimum!',
    pleaseAdd: 'Mohon untuk menambahkan akun',
    accountUnderSection: 'pada bagian Akun.',
    'com.asyx.x4.document.pranota.invoice_amount_greater_than_total_pranota_amount':
        'Nilai invoice melebihi total nilai pranota.',
    'com.asyx.x4.document.pranota.already_used': 'Invoice reference sudah digunakan.',
    invalidDueDate: 'Tanggal Jatuh Tempo tidak boleh kurang dari Tanggal Invoice.',
    'com.asyx.x4.invoices.invalid_due_date':
        'Tanggal Jatuh Tempo tidak boleh kurang dari Tanggal Invoice.',
};
